import React from 'react';
import { useIntl } from 'react-intl';
import { Body } from '../Typography/index.js';
import { NoResultsAvailableSVG } from './NoResultsAvailableSVG.js';
import { twMerge } from '@panwds/tailwindcss';
/**
 * Layout for an empty state graphic, heading, description, and follow up actions.
 *
 * @replacement `@panwds/react-aria-components#NoData`
 */
const MIN_PADDING = '16px';
const MAX_HORIZONTAL_PADDING = '64px';
const MAX_VERTICAL_PADDING = '32px';
const CONTENT_WIDTH = '700px';
const BOTTOM_MIN_PADDING = '24px';
const paddingClamp = (min, max) => `clamp(${min}, calc((100% - ${CONTENT_WIDTH}) * 9999), ${max})`;
export function EmptyStateLayout({ actions, description, graphic, heading, style, className }) {
    const intl = useIntl();
    const graphicIcon = graphic ?? React.createElement(NoResultsAvailableSVG, null);
    return (React.createElement("div", { className: twMerge('twds-flex twds-justify-center', className?.root) },
        React.createElement("div", { className: twMerge('twds-flex twds-flex-col twds-items-center twds-space-y-6', className?.container), style: {
                paddingLeft: paddingClamp(MIN_PADDING, MAX_HORIZONTAL_PADDING),
                paddingRight: paddingClamp(MIN_PADDING, MAX_HORIZONTAL_PADDING),
                paddingTop: paddingClamp(MIN_PADDING, MAX_VERTICAL_PADDING),
                paddingBottom: paddingClamp(BOTTOM_MIN_PADDING, MAX_VERTICAL_PADDING),
                ...style
            } },
            graphicIcon && (React.createElement("div", { className: twMerge('twds-flex twds-max-h-[5.625rem] twds-w-full twds-justify-center', className?.graphic) }, graphicIcon)),
            React.createElement("div", { className: twMerge('twds-text-center twds-flex twds-flex-col twds-gap-2', className?.contentWrapper) },
                React.createElement(Body, { level: 4, size: "md", dataTestId: "heading", addClassName: className?.heading }, heading ??
                    intl.formatMessage({
                        defaultMessage: 'No Results Available',
                        id: 'Q58RPw',
                        description: 'No results available for section'
                    })),
                description && (React.createElement(Body, { appearance: "secondary", size: "sm", dataTestId: "description", addClassName: className?.description }, description))),
            actions)));
}
//# sourceMappingURL=EmptyStateLayout.js.map